import { configureStore } from '@reduxjs/toolkit'
import { api, queryReducers } from 'mmfintech-checkout-commons'
import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'

import './i18n'

import 'react-datepicker/dist/react-datepicker.css'
import 'mmfintech-portal-commons/dist/main.css'
import './index.css'
import './scss/app.scss'

export const store = configureStore({
  reducer: queryReducers,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware)
})

const rootContainer = document.getElementById('checkout-app')
const root = ReactDOMClient.createRoot(rootContainer)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)
